import angular from "angular";
import { angularJsApp } from "../app";
import _ from "lodash";
import { AppComponentsEnum } from "../app.model";
import { DataService } from "../services/data.service";
import { CentresPreinscripcioService } from "../services/centres-preinscripcio.service";
import { EnsenyamentsPreinscripcioCercaService } from "../services/ensenyaments-preinscripcio-cerca.service";
import { EnsenyamentsPreinscripcioData } from "../services/ensenyaments-preinscripcio-data.service";
import { CentresService } from "../services/centres.service";
import { Ofertes } from "../services/ofertes.service";
import { NotificationsService } from "../services/notification.service";
import { ServeisSuports } from "../services/serveis-suports.service";
import { SharedProperties } from "../services/share.service";
import { APP_BASE_CONFIG } from ".";
import { ServeisEducatius } from "../services/serveis-educatius.service";

class Component {
  public pilotoOcultacioInclusiva;
  centres = [];
  sortBy
  selectedTab
  showAdscritsIcon
  currentPage
  excelExporting
  activarCraerUrl = this.$rootScope.cercaClick;
  SORT_ASC = "asc";
  SORT_DESC = "desc";
  SORT_ASC_CLASS = "glyphicon-sort-by-attributes";
  SORT_DESC_CLASS = "glyphicon-sort-by-attributes-alt";
  paramsExcel = {};
  llistatStyle = {};
  llistatWait = false;
  totalItems = 0;
  sortDirection = "";
  sortCodi = { sortDirection: this.SORT_ASC, sortClass: this.SORT_ASC_CLASS };
  sortNom = { sortDirection: this.SORT_ASC, sortClass: this.SORT_ASC_CLASS };
  sortMunicipi = { sortDirection: this.SORT_ASC, sortClass: this.SORT_ASC_CLASS };
  filtes = {};
  onCenterCentreOnMap

  constructor(
    private $scope,
    private $rootScope,
    private DataService: DataService,
    private Ofertes: Ofertes,
    private Centres: CentresService,
    private ServeisEducatius: ServeisEducatius,
    private ServeisSuports: ServeisSuports,
    private CentresPreinscripcio: CentresPreinscripcioService,
    private EnsenyamentsPreinscripcioData: EnsenyamentsPreinscripcioData,
    private SharedProperties: SharedProperties,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private $timeout,
    private EnsenyamentsPreinscripcioCercaService: EnsenyamentsPreinscripcioCercaService,
    private NotificationsService: NotificationsService,
  ) { }

  $onInit() {
    angular.extend(this, this.DataService.getData());
    this.setupListeners();
  }

  pageChanged() {
    //lanzamos un timeout si el cambio de página tarda mucho en cargar nuevos registros
    //mostramos un div con un icono "Waiting" y se baja la opacidad del listado
    const timeOut = this.llistLoad();
    const registreInicial = (Number(this.currentPage) * paramsMapes.rpp) - paramsMapes.rpp + 1;
    paramsMapes.registreInicial = registreInicial;
    paramsMapes.registreFinal = Number(registreInicial + paramsMapes.rpp - 1);
    //Condicional per a cridar els diferents serveis en funció del tipus de cerca (centres o SE)
    switch (this.selectedTab) {
      case 0:
        this.getPagePreinscripcio(paramsMapes, timeOut);
        break;
      case 1:
        this.getPageOferta(paramsMapes, timeOut);
        break;
      case 2:
        this.getPageServeis(paramsMapes, timeOut);
        break;
    }
  }

  getPagePreinscripcio(paramsMapes, timeout) {
    this.CentresPreinscripcio.getCentresPreinscripcio(paramsMapes).then((data) => {
      this.setPaginationData(data, timeout);
    });
  }

  getPageOferta(paramsMapes, timeout) {
    this.Centres.getCentres(paramsMapes).then((data) => {
      this.setPaginationData(data, timeout);
    });
  }

  getPageServeis(paramsMapes, timeout) {
    this.ServeisEducatius.getCentres(paramsMapes).then((data) => {
      this.setPaginationData(data, timeout);
    });
  }

  setPaginationData(data, timeout) {
    if (timeout) {
      this.llistLoadClear(timeout);
    }
    this.DataService.listCentres.centres = data.centres;
    this.DataService.listCentres.totalItems = data.registresTotal;
    this.SharedProperties.setNumResults(data.registresTotal);
    angular.extend(this, this.DataService.listCentres);
  }

  //Mètode que inhabilita la llista mentre carrega i li aplica un estil
  llistLoad() {
    return this.$timeout(() => {
      this.$rootScope.$broadcast('showOverlayLoader');
    }, 400);
  }

  //Mètode que allibera la llista
  llistLoadClear(timeOut) {
    this.$timeout.cancel(timeOut);
    this.$rootScope.$broadcast('hideOverlayLoader');
  }

  //RbSierra
  //Funció que crida el Modal que s'encarregarà de mostrar la informació dels ensenyaments pel centre SFP
  showOfertaCentreSFP(centre, params?) {
    let modalInstance;
    switch (this.selectedTab) {
      case 0:
        this.SharedProperties.openLoader();
        modalInstance = this.$uibModal.open(
          {
            animation: true,
            templateUrl: './components/modal-centres-vacants-preinscripcio.component.html',
            controller: 'listVacantsPreinscripcioController',
            size: 'lg',
            windowClass: 'center-modal',
            resolve: {
              'ofertaCentreSFP': () => this.CentresPreinscripcio.getCentrePreinscripcio({ ...centre, ...(params || {})}),
              'selectedEnsenyaments': () => {
                var ariFilter = this.EnsenyamentsPreinscripcioData.getAriFilter();
                return Promise.all(ariFilter.map((item) => {
                  if (item.cicles.length !== 0 || item.families.length !== 0 || item.estudis.length !== 0) {
                    return this.findEstudisFrom(item);
                  } else {
                    return this.findEstudisFromSubnodes(item);
                  }
                })).then((dades) => {
                  var estudis_aux = [];
                  dades.forEach((estudis) => {
                    if (estudis && estudis != undefined) {
                      estudis.forEach((e) => {
                        estudis_aux = estudis_aux.concat(this.tractarNode(e));
                      });
                    }
                  });
                  return estudis_aux;
                });
              },
              'centre': () => centre,
              'selectorCurs': () => this.SharedProperties.getSelectedCurs(),
              'selectedApiFilter': () => this.filtes,
            }
          }
        );
        break;
      default:
        modalInstance = this.$uibModal.open(
          {
            animation: true,
            component: AppComponentsEnum.CENTRES_SFP,
            size: 'lg',
            windowClass: 'center-modal',
            resolve: {
              'ofertaCentreSFP': this.selectedTab === 2 ? () => ({}) : () => this.Ofertes.getOfertaCentre(centre, params),
              'centre': () => centre,
              'selectorCurs': this.selectedTab === 2 ? () => ({}) : () => this.SharedProperties.getSelectedCurs(),
            }
          }
        );
        break;
    }
  }

  tractarNode(node) {
    if (node.tipusNode === 'MODALITAT_FAMILIA') {
      return this.recoreNodes(node);
    } else {
      return [node];
    }
  }

  recoreNodes(node) {
    if (node.subnodes && node.subnodes.length == 0) {
      if (node.tipusNode == 'ESTUDI') {
        return [node];
      }
      else {
        return [];
      }
    } else {
      var listaNodes = [];
      node.subnodes.forEach((n) => {
        listaNodes = listaNodes.concat(this.recoreNodes(n));
      });
      return listaNodes;
    }
  }

  findEstudisFrom(item) {
    var selected_options = this.getSelectedOptions(item);
    var estudisSeleccionats = this.getEstudisCodisFromEstudis(item);
    if (item.tipus.codi.includes('BATXLOE')) {
      return item.estudis;
    } else {
      return this.EnsenyamentsPreinscripcioCercaService.getFamiliesFromGraus(
        item.tipus.codi, selected_options).then((dades) => {
          if (item.families && item.families.length == 0) {
            var codisCicles = [];
            dades.forEach((cicle) => {
              codisCicles.push(cicle.codis);
            });
            selected_options.families = codisCicles;
          }
          return this.EnsenyamentsPreinscripcioCercaService.getEstudisFromFamilies(
            item.tipus.codi, selected_options)
        }).then(((estudis) => {
          return this.filtrarSegonsEstudiSelecionat(estudis, estudisSeleccionats);
        }));
    }
  }

  filtrarSegonsEstudiSelecionat(estudis, estudisSeleccionats) {
    if (estudisSeleccionats && estudisSeleccionats.length > 0) {
      var estudisFiltrats = [];
      estudis.forEach((e) => {
        var trobat = false;
        var i = 0;
        while (!trobat && i < e.codis.length) {
          if (estudisSeleccionats.includes(e.codis[i])) {
            estudisFiltrats.push(e);
            trobat = true;
          }
          i++;
        }
      });

      return estudisFiltrats;
    } else {
      return estudis;
    }
  }

  getEstudisCodisFromEstudis(item) {
    var estudis = [];
    if (item.estudis && item.estudis.length > 0) {
      item.estudis.forEach((e) => {
        if (e.codis) {
          for (var i = 0; i < e.codis.length; i++) {
            estudis.push(e.codis[i]);
          }
        }
      });
    }
    return estudis;
  }

  findEstudisFromSubnodes(item) {
    var estudisSelecionats = [];
    if (item.nivells && item.nivells.length) {
      var nivells = _.flatten(_.map(item.nivells, 'id'));
      item.tipus.subnodes.forEach((estudi) => {
        var trobat = false;
        var i = 0;
        while (!trobat && i < nivells.length) {
          if (estudi.codi.includes(nivells[i].toString())) {
            estudisSelecionats.push(estudi);
            trobat = true;
          }
          i++;
        }
      })
    } else {
      estudisSelecionats = item.tipus.subnodes;
    }

    return Promise.resolve(estudisSelecionats);
  }

  getSelectedOptions(item) {
    var ciclesQuery = [];
    var familiesQuery = [];
    ciclesQuery.push(_.map(item.cicles, 'codi'));
    familiesQuery.push(_.flatten(_.map(item.families, 'codis')));
    return {
      graus: ciclesQuery,
      families: familiesQuery
    };
  }

  //Funció que crida el Modal que mostra la informació dels centres adscrits
  showCentresAdcrits(centre) {
    var modalInstance = this.$uibModal.open(
      {
        animation: true,
        component: AppComponentsEnum.CENTRES_AD,
        size: 'lg',
        resolve: {
          centresAdscrits: () => {
            switch (this.selectedTab) {
              case 0:
                return this.CentresPreinscripcio.getCentresPreinscripcioAdscrits(centre.codiCentre);
              case 1:
                return this.Centres.getCentresAdscrits(centre.codiCentre);
            }
          },
          centresAdscritsPare: () => {
            switch (this.selectedTab) {
              case 0:
                return this.CentresPreinscripcio.getCentresPreinscripcioAdscritsPare(centre.codiCentre);
              case 1:
                return this.Centres.getCentresAdscritsPare(centre.codiCentre)
            }
          },
          'centre': () => {
            return centre;
          },
          selectedTab: this.selectedTab,
        }
      }
    );

    modalInstance.result.then((data) => {
      var filter = data.filter;
      var bboxObj = data.bboxObj;
      this.onCenterCentreOnMap({
        data: { filter: filter, dataGeoserver: data.dataGeoserver, },
        bboxObj: bboxObj,
      });
    }, (result) => {
      var status = result?.status;
      switch (status) {
        case 'OPEN_SFP':
          var centre = result.data;
          this.showOfertaCentreSFP(centre);
      }
    });
  }

  //Mètode que crida un modal en funció del tipus de Servei Educatiu
  showCentresSE(centre) {
    //Si són CREDAV, CREDAS o Camps d'aprenentatge
    if (centre.tipus === 42 || centre.tipus === 43 || centre.tipus === 45) {
      this.$uibModal.open(
        {
          animation: true,
          component: AppComponentsEnum.CENTRES_SE_TERRITORI,
          size: 'lg',
          resolve: {
            'tipusSE': () => centre.tipus,
          }
        }
      )
    } else {
      this.$uibModal.open(
        {
          animation: true,
          templateUrl: './components/modal-centres-adscrits-se.component.html',
          controller: 'listCentresSEController',
          size: 'lg',
          resolve: {
            centresAdscritsSE: this.Centres.getCentresAdscritsSE(centre.codiCentre),
            'centre': () => centre,
          }
        }
      )
    }
  }

  showCentresSuport(centre) {
    this.$uibModal.open(
      {
        animation: true,
        component: AppComponentsEnum.CENTRES_SUPORTS,
        size: 'lg',
        resolve: {
          centres: this.ServeisSuports.getCentresSuport(centre.codiCentre),
          centre,
          selectedTab: this.selectedTab,
        }
      }
    ).result.then((result) => {
      if (!result) { return; }
      const { filter, bboxObj, dataGeoserver } = result;
      this.onCenterCentreOnMap({
        data: { filter, dataGeoserver },
        bboxObj: bboxObj,
      });
    })
  }

  showCentresServeis(centre) {
    this.$uibModal.open(
      {
        animation: true,
        component: AppComponentsEnum.CENTRES_SUPORTS,
        size: 'lg',
        resolve: {
          centres: this.ServeisSuports.getCentresServeis(centre.codiCentre),
          centre,
          selectedTab: this.selectedTab,
          haveCenters: true,
        }
      }
    ).result.then((result) => {
      if (!result) { return; }
      const { filter, bboxObj, dataGeoserver } = result;
      this.onCenterCentreOnMap({
        data: { filter, dataGeoserver },
        bboxObj: bboxObj,
        layer: APP_BASE_CONFIG.geoServerServeisEducatiusLayersTwo
      });
    })
  }
  
  showCentresMunicipis(centre, type) {
    this.$uibModal.open(
      {
        animation: true,
        component: AppComponentsEnum.CENTRES_SUPORTS,
        size: 'lg',
        resolve: {
          centres: this.ServeisEducatius.getCentreDetail(centre.codiCentre, type),
          centre,
          selectedTab: this.selectedTab,
          haveCenters: type === 'C',
        }
      }
    ).result.then((result) => {
      if (!result) { return; }
      const { filter, bboxObj, dataGeoserver } = result;
      this.onCenterCentreOnMap({
        data: { filter, dataGeoserver },
        bboxObj: bboxObj,
        layer: APP_BASE_CONFIG.geoServerOfertaLayers
      });
    })
  }

  exportar() {
    if (Object.keys(this.paramsExcel).length !== 0) {
      if (this.DataService.listCentres.totalItems !== 0) { 
        this.excelExporting = true; 
        switch (this.selectedTab) {
          case 0:
            this.Centres.exportarCentresPreinscripcio(this.paramsExcel).then(() => {
              this.excelExporting = false;
            }, this.setExportError);
            break;
          case 1:
            this.Centres.exportarCentres(this.paramsExcel).then(() => {
              this.excelExporting = false;
            }, this.setExportError);
            break;
          case 2:
            this.ServeisEducatius.exportarCentres(this.paramsExcel).then(() => {
              this.excelExporting = false;
            }, this.setExportError);
          break;
        }
      }
    }
  };

  setExportError = () => {
    this.NotificationsService.sendMessage("Hi ha hagut un problema al generar el document", "info");
    this.$rootScope.$broadcast('error');
    this.excelExporting = false;
  }

  centerCentre(centre) {
    if (this.checkCoords(centre) === true) {
      var bboxObj = { bboxGeo: [], bboxCentre: [] };
      var filter = this.SharedProperties.getLastFilter();
      var offset = 100;
      var coordX = Number((centre.coordX).replace(",", "."));
      var coordY = Number((centre.coordY).replace(",", "."));
      var minX = coordX - offset;
      var minY = coordY - offset;
      var maxX = coordX + offset;
      var maxY = coordY + offset;
      var estudisCentre = this.DataService.getAllEstudisByCodiCentre(centre.codiCentre);

      bboxObj.bboxCentre = [minX, minY, maxX, maxY];
      this.onCenterCentreOnMap({
        data: { filter: filter, estudisCentre: estudisCentre },
        bboxObj: bboxObj
      });
    }
  };

  //Funció que comprova si estan informades les coordenades. Es fa servir a la vista i com a prevenció a centerCentre()
  checkCoords(elem) {
    var areCoordsNotified = true;
    if (elem.coordX == null || elem.coordY == null || elem.coordX === "" || elem.coordY === "") {
      areCoordsNotified = false;
    }

    return areCoordsNotified;
  };

  //Mètode per a l'enllaç de la FDC
  openWindow(centre) {
    this.$uibModal.open(
      {
        animation: true,
        component: AppComponentsEnum.FITXA_CENTRE,
        size: 'xl',
        resolve: { centre },
      }
    );
  };

  private setupListeners() {
    this.$rootScope.$watch('cercaClick', (newValue, oldValue) => {
      this.activarCraerUrl = newValue;
    });
    //Mètode que espera un broadcast de 'searchDone', extén a l'scope la nova llista cercada i fa
    //set dels paràmetres de l'excel, que es mantenen fixes fins que no es fa una cerca nova
    this.$scope.$on('searchDone', () => {
      angular.extend(this, this.DataService.listCentres);
      this.paramsExcel = { ...this.paramsExcel, ...this.paramsExcel, ...paramsMapes };
      this.showAdscritsIcon = this.DataService.cercarPer;
      this.currentPage = 1;
      this.filtes = angular.copy(this.EnsenyamentsPreinscripcioData.getAriFilter());
    });
    this.$scope.$on('clear', () => {
      this.centres = [];
      this.totalItems = 0;
    }, true);
    this.$scope.$on('openPopupCentrePreinscripcio', (event, codiCentre) => {
      this.SharedProperties.openLoader();
      var modalInstance = this.$uibModal.open(
        {
          animation: true,
          templateUrl: './components/modal-centres-vacants-preinscripcio.component.html',
          controller: 'listVacantsPreinscripcioController',
          size: 'lg',
          windowClass: 'center-modal',
          resolve: {
            'ofertaCentreSFP': () => this.CentresPreinscripcio.getCentrePreinscripcio({ codiCentre: codiCentre }),
            'selectedEnsenyaments': () => {
              var ensenyaments = this.EnsenyamentsPreinscripcioData.getEnsenyamentsFromAriFilter();
              return _.uniqBy(this.findByEstudi(ensenyaments), 'id');
            },
            'centre': () => {
              return this.Centres.getCentres({ codiCentre: codiCentre }).then((data) => {
                return _.first(data.centres);
              });
            },
            'selectorCurs': () => this.SharedProperties.getSelectedCurs(),
            'selectedApiFilter': () => this.filtes,
          }
        }
      );
      modalInstance.result.then(() => {
      }, () => {
      });
    })
    this.$scope.$on('openPopupServeiEducatiu', (event, centre) => {
      this.SharedProperties.openLoader();
      this.$uibModal.open(
        {
          animation: true,
          component: AppComponentsEnum.CENTRES_SUPORTS,
          size: 'lg',
          resolve: {
            centre: {
              codiCentre: centre.COD_CENTRES_DOCENTS,
              nom: centre.NOM_CENTRE,
              adresa: centre.DOMICILI_CENTRES_DOCENTS,
            },
            selectedTab: this.selectedTab,
          }
        }
      )
    })
  }

  findByEstudi(obj) {
    var objects = [];
    for (var i in obj) {
      if (!obj.hasOwnProperty(i)) {
        continue;
      }
      if (typeof obj[i] === 'object') {
        objects = objects.concat(this.findByEstudi(obj[i]));
      } else {
        if (obj.tipusNode === 'ESTUDI') {
          objects.push(obj);
        }
      }
    }
    return objects;
  }
}

const component: ng.IComponentOptions = {
  bindings: {
    selectedTab: '<',
    pilotoOcultacioInclusiva: '<',
    onCenterCentreOnMap: '&'
  },
  templateUrl: './components/centres.component.html',
  controller: Component,
};

angularJsApp.component(AppComponentsEnum.CENTRES, component);
